<template>
<!-- <div> -->
    <v-dialog
      :value="dialog"
      width="100%"
      class="dialog"
      @click:outside="close"
    >
        <div class="wrapper">
            <img src="../assets/modal/close.png" alt="" class="close" @click="close" v-if="currentComponent !='wishShareGuide'" >
            <component :is="currentComponent" 
                :wishData="wishData"
                :ownWish="{wishId, wishComment}"
                :userInfo="userInfo"
                :socksIndex="socksIndex"
                :currentCom="dialog"
                :wishCount="wishCount"
                :myWish="myWish"
                @wishBoard-confirm="handleWishConfirm"
                @wishComment-confirm="handleComment"
                @wishComplete-confirm="$emit('wishComplete');close()"
                @wishComplete-reselect="transition('wishBoard')"
                @wishRandom-check="transition('wishOwn')"
                @wishShareTip-share="transition('wishShareCard')"
                @wishShareComplete-cofirm="transition('wishBoard')"
                @wishShareFail-cofirm="transition('wishShareCard')"
                @loginTip-confirm="handleLogin"
                @wishOwn-confirm="transition('wishShareTip')"
                @wishOwn-towish="transition('wishBoard')"
                @wishShareCard-complete="handleShare"
                @wishShareGuide-confirm="transition('wishShareComplete')"
            />
        </div>
    </v-dialog>
<!-- </div> -->
</template>

<script>
import wishBoard from '@/components/modal/wishBoard'
import wishComment from '@/components/modal/wishComment'
import wishComplete from '@/components/modal/wishComplete'
import wishRandom from '@/components/modal/wishRandom'
import wishShareTip from '@/components/modal/wishShareTip'
import wishShareCard from '@/components/modal/wishShareCard'
import wishShareComplete from '@/components/modal/wishShareComplete'
import wishShareGuide from '@/components/modal/wishShareGuide'
import wishSocks from '@/components/modal/wishSocks'
import loginTip from '@/components/modal/loginTip'
import wishOwn from '@/components/modal/wishOwn'
export default {
    name: 'modalWrapper',
    // 0初始状态 1许愿弹框 2我还想说 3许愿结束
    // 4别人的愿望 5查看我的愿望 6分享愿望提示 7分享卡片 8分享成功提示 9分享的遮罩提示
    // 10登录提示 11查看所有人的愿望 
    props: ['dialog', "activated", "userInfo", "wishData", "socksIndex", "wishCount", "myWish"],
    components: {
        wishBoard,
        wishComment,
        wishComplete,
        wishRandom,
        wishShareTip,
        wishShareCard,
        wishShareComplete,
        wishShareGuide,
        wishSocks,
        loginTip,
        wishOwn
    },
    watch: {
        activated(newV, oldV) {
            console.log({newV})
            this.transition(newV)
        }
    },
    computed: {
        currentComponent() {
            if (!this.userInfo && (this.activated != 'wishRandom' || (this.current && this.current != 'wishRandom'))) {
                return 'loginTip'
            }
            return 'loginTip'
        }
    },
    data() {
        return {
            current: '',
            transitions: [
                {
                    name: 'wishBoard',
                    from: [0, 3], to: 1
                },
                {
                    name: 'wishComment',
                    from: 1, to: 2
                },
                {
                    name: 'wishComplete',
                    from: 2, to: 3
                },
                {
                    name: 'wishRandom',
                    from: 0, to: 4
                },
                {
                    name: 'wishCheck',
                    from: 4, to: 5
                },
                {
                    name: 'wishShareTip',
                    from: 5, to: 6
                },
                {
                    name: 'wishShareCard',
                    from: 6, to: 7
                },
                {
                    name: 'wishShareComplete',
                    from: 7, to: 8
                },
                {
                    name: 'wishShareGuide',
                    from: 7, to: 9
                },
                {
                    name: 'loginTip',
                    from: 0, to: 10
                },
                {
                    name: 'wishSocks',
                    from: 0, to: 11
                },
                {
                    name: 'wishOwn',
                    from: 0, to: 12
                }
            ],
            wishId: '',
            wishComment: ''
        }
    },
    methods: {
        transition(s) {
            console.log(this.userInfo)
            this.current = s
        },
        handleWishConfirm(id) {
            this.wishId = id
            this.transition('wishComment')
        },
        handleComment(s) {
            this.wishComment = s
            this.transition('wishComplete')
        },
        makeWish() {

        },
        handleShare() {
            this.$emit('shareSucc')
            this.transition('wishShareGuide')
        },
        handleLogin() {
            this.$emit('close')
            this.$emit('login')
        },
        close() {
            this.current = ''
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog {
    margin: 0;
}
.wrapper {
    position: relative;
    overflow: hidden;
}
.close {
    width: 15.1vw;
    position: absolute;
    right: 4vw;
    z-index: 100;
}
</style>